// Copyright (c) 2016 Deere & Company

import './app-logo.scss';
import React from 'react';

const AppLogo = () => <span className='app-logo'/>;

AppLogo.displayName = 'AppLogo';

export default AppLogo;



// WEBPACK FOOTER //
// ./src/app/app-logo.js